import React from 'react';
import MainLayoutFunctional from './components/main-layout-functional';
import './main-layout.scss';

const MainLayout = () => {
	return <MainLayoutFunctional />;
};

export default MainLayout;
